/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 18.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataWidget from "./DataWidget";
import DataProvider from "../DataProvider";

class DataItem extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired,
        title: PropTypes.string,
        type: PropTypes.oneOf(["tr", "li", "div", "span"]),
        widgetType: PropTypes.oneOf(["view", "edit"]),
        hideEmpty: PropTypes.bool
    };

    static defaultProps = {
        type: "",
        widgetType: "view",
        hideEmpty: true
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    getTitle() {
        let title = this.props.title;
        if (title == null) {
            // Get title from schema:
            title = this.props.dataProvider.getSchema().field(this.props.field).getTitle();
        }
        return title;
    }

    renderTableRow() {
        let title = this.getTitle();
        if (title) title += ":";
        return (
            <tr>
                <th>{title}</th>
                <td>
                    <DataWidget dataProvider={this.props.dataProvider} field={this.props.field} type={this.props.widgetType}/>
                </td>
            </tr>
        );
    }

    renderListItem() {
        let title = this.getTitle();
        if (title) title += ": ";
        return (
            <li>
                {title}<DataWidget dataProvider={this.props.dataProvider} field={this.props.field} type={this.props.widgetType}/>
            </li>
        );
    }

    renderDiv() {
        let title = this.getTitle();
        if (title) title += ":";
        return (
            <div className="row">
                <div className="col-md-3">{title}</div>
                <div className="col-md-9"><DataWidget dataProvider={this.props.dataProvider} field={this.props.field} type={this.props.widgetType}/></div>
            </div>
        );
    }

    renderSpan() {
        let title = this.getTitle();
        if (title) title += ": ";
        return (
            <span>
                {title}<DataWidget dataProvider={this.props.dataProvider} field={this.props.field} type={this.props.widgetType}/>
            </span>
        );
    }

    render() {
        let value = this.props.dataProvider.getValue(this.props.field);
        if (value == null && this.props.hideEmpty) return null;

        switch (this.props.type) {
            case "tr":
                return this.renderTableRow();
            case "li":
                return this.renderListItem();
            case "div":
                return this.renderDiv();
            case "span":
                return this.renderSpan();
            default:
                return (<DataWidget dataProvider={this.props.dataProvider} field={this.props.field} type={this.props.widgetType}/>);
        }
    }
}

export default DataItem;
